/**
 * Shared warehouse utility functions.
 * Extracted from common patterns across warehouse tab components and dialogs.
 */

/**
 * Filter items by date range.
 * @param {Object} item - Item with a date field
 * @param {string} dateField - Property name for the date (e.g., 'document_date', 'created_at')
 * @param {string} from - Start date string (YYYY-MM-DD)
 * @param {string} to - End date string (YYYY-MM-DD)
 * @returns {boolean}
 */
export function isInDateRange(item, dateField, from, to) {
  
  if (!from || !to) return true;
  const itemDate = new Date(item[dateField] + "T12:00:00");
  const fromDate = new Date(from + "T00:00:00");
  const toDate = new Date(to + "T23:59:59");
  return itemDate >= fromDate && itemDate <= toDate;
}

/**
 * Filter items by date range using created_at (datetime field, no T12:00:00 offset).
 * @param {Object} item - Item with created_at field
 * @param {string} from - Start date string (YYYY-MM-DD)
 * @param {string} to - End date string (YYYY-MM-DD)
 * @returns {boolean}
 */
export function isCreatedInDateRange(item, from, to) {
  if (!from || !to) return true;
  const dateEnd = to + " 23:59:59";
  return (
    new Date(item.created_at) >= new Date(from) &&
    new Date(item.created_at) <= new Date(dateEnd)
  );
}

/**
 * Group items by warehouse.
 * Used by: TabPurchase, TabEntry, TabInvoice, TabReturn, TabWriteOff, TabTransaction
 *
 * @param {Array} items - Array of items with warehouse_id and warehouse object
 * @param {string} fallbackName - Fallback warehouse name (e.g., $t('stock'))
 * @returns {Object} Grouped items keyed by warehouse_id
 */
export function groupByWarehouse(items, fallbackName = "Stock") {
  const groups = {};
  items.forEach((item) => {
    const warehouseId = item.warehouse_id;
    if (!groups[warehouseId]) {
      groups[warehouseId] = {
        warehouseName: item.warehouse?.name || fallbackName,
        items: [],
      };
    }
    groups[warehouseId].items.push(item);
  });
  return groups;
}
